var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-md"},[_c('Start',{on:{"load-example":_vm.onLoadExample,"load-url":_vm.onLoadUrl,"load-file":_vm.onLoadFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }